"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageService = void 0;
const imagemodel_1 = require("../model/imagemodel");
class ImageService {
    constructor($q, $http, $rootScope, uploadService, assetFormats, toolbox) {
        this.$q = $q;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.uploadService = uploadService;
        this.assetFormats = assetFormats;
        this.toolbox = toolbox;
        this.extentionAssetFormatMap = {
            'jpg': 'jpg',
            'jpeg': 'jpg',
            'gif': 'gif',
            'eps': 'eps',
            'svg': 'svg',
            'tif': 'tiff',
            'tiff': 'tiff'
        };
        this.baseUrl = 'Api/Images/';
        this.getCookieValue = (name) => {
            var _a;
            return (
            // https://stackoverflow.com/questions/5639346/what-is-the-shortest-function-for-reading-a-cookie-by-name-in-javascript
            ((_a = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')) === null || _a === void 0 ? void 0 : _a.pop()) || '');
        };
    }
    getImage(imageId) {
        const uri = `${this.baseUrl}${imageId}`;
        return this.$http.get(uri).then(response => new imagemodel_1.ImageModel(response.data));
    }
    getAssetFormats(imageId) {
        const uri = `${this.baseUrl}${imageId}/AssetFormats`;
        return this.$http.get(uri).then((response) => response.data);
    }
    upload(imageId, file) {
        const uri = `${this.baseUrl}${imageId}`;
        return this.uploadService.upload(uri, 'PUT', file).then(response => response === null || response === void 0 ? void 0 : response.data);
    }
    async downloadImage(imageId, assetFormat) {
        const uri = `${this.baseUrl}${imageId}/${assetFormat}`;
        // Add images: images can't be cached at the moment
        const url = this.toolbox.addCacheBuster(uri.toString());
        const xsrfValue = decodeURIComponent(this.getCookieValue("XSRF-TOKEN"));
        const options = {
            headers: {
                "X-XSRF-TOKEN": xsrfValue
            }
        };
        const result = await fetch(url, options);
        const blob = await result.blob();
        const blobImageUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.setProperty('display', 'none');
        document.body.appendChild(a);
        a.download = imageId + "." + assetFormat;
        a.href = blobImageUrl;
        a.click();
        a.remove();
        URL.revokeObjectURL(blobImageUrl);
    }
    async SetImagePreviewUrl(imageId, imgElement) {
        const uri = `${this.baseUrl}preview/${imageId}`;
        // Add images: images can't be cached at the moment
        const url = this.toolbox.addCacheBuster(uri.toString());
        const xsrfValue = decodeURIComponent(this.getCookieValue("XSRF-TOKEN"));
        const options = {
            headers: {
                "X-XSRF-TOKEN": xsrfValue
            }
        };
        const result = await fetch(url, options);
        const blob = await result.blob();
        const blobImageUrl = URL.createObjectURL(blob); // We release it just before loading the next image or when unloading the document
        imgElement.src = blobImageUrl;
    }
    getAssetFormatFromFilename(filename) {
        var extension = filename.split('.').pop().toLowerCase();
        return this.extentionAssetFormatMap[extension];
    }
}
exports.ImageService = ImageService;
ImageService.$inject = ['$q', '$http', '$rootScope', 'uploadService', 'assetFormats', 'toolbox'];
